"use strict";
import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import Formsy from "./formsy";
import FormsyFormErrorsProvider from "./formsyFormErrorsProvider";

const initComponent = (flex = window.flex) => {

    class FlexModal extends React.Component {
        static childContextTypes = {
            formHandler: PropTypes.object,
            formRef: PropTypes.object
        };

        static propTypes = {
            isLoading: PropTypes.bool,
            validateOnFormMount: PropTypes.bool,
            isSubmitDisabled: PropTypes.bool
        };

        static defaultProps = {
            isLoading: false,
            validateOnFormMount: false,
            isSubmitDisabled: false
        };

        constructor(props) {
            super(props);

        this.state = {
            canSubmit: false,
            isFormPristine: true,
            formHandler: {
                closeModal: this.close,
                resetForm: this.resetForm,
                hideSpinner: this.hideSpinner,
                showSpinner: this.showSpinner,
                isValid: false
            },
            show: (typeof props.show === "undefined") ? true : props.show
        };

        this.submitRef = React.createRef();
    }

        getChildContext() {
            const state = this.state;
            const formHandler = this.state.formHandler || {};
            if (formHandler.canSubmit) formHandler.canSubmit(!state.isFormPristine && state.canSubmit);
            return { formHandler: this.state.formHandler };
        }

        componentDidMount() {
            const props = this.props;
            flex.log(`MODAL LAUNCHED: `, props);
        }

        componentDidUpdate() {
            const { isSaving = null } = this.props;
            if (isSaving && typeof isSaving === 'function') {
                const isSavingResult = isSaving();
                if (isSavingResult) {
                    if (this.submitRef?.current && !this.state.loadingSpinner) {
                        const loadingSpinner = flex.showSpinner(this.submitRef.current);
                        this.setState({ loadingSpinner: loadingSpinner });
                    }
                } else if (this.state.loadingSpinner) {
                    flex.hideSpinner(this.state.loadingSpinner, () => { });
                    this.setState({ loadingSpinner: null });
                }
            }
        }

        initFormErrorsProvider = (provider) => {
            this.formErrorsProvider = provider;
        };

        close = () => {
            this.setState({ show: false });
            flex.log(`MODAL CLOSED: `);
            // pause for effect
            setTimeout(() => {
                const props = this.props;
                if (props.onClose) props.onClose();
            }, 300);
        };

        resetForm = () => {
            this.refs.modalForm.reset();
            this.refs.modalForm.resetModel();
        };

        formChanged = (currentValues, isChanged) => { this.setState({ isFormPristine: !isChanged }); };

    enableSubmit = () => {
        const formHandler = this.state.formHandler || { };

        this.setState({
            canSubmit: true,
            formHandler: {
                ...formHandler,
                isValid: true
            }
        });
    };

    disableSubmit = () => {
        const formHandler = this.state.formHandler || { };

        this.setState({
            canSubmit: false,
            formHandler: {
                ...formHandler,
                isValid: false
            }
        });
    };

        handleSubmit = (model, reset, invalidate, addFormErrors, clearFormErrors) => {
            const formHandler = this.state.formHandler || {};
            if (formHandler.onSubmit) formHandler.onSubmit(model, reset, invalidate, addFormErrors, clearFormErrors);
            else flex.log("WARNING: form was submitted without an onSubmit() specified for formHandler");
        };

    clearFormErrors = (...params) => {
        return this.formErrorsProvider.clearFormErrors(...params);
    };

    showSpinner = () => {
        const loadingSpinner = flex.showSpinner(this.submitRef.current);
        this.setState({ loadingSpinner: loadingSpinner });
    }

    hideSpinner = () => {
        flex.hideSpinner(this.state?.loadingSpinner);
        this.setState({ loadingSpinner: null })
    }

    render() {
        const self = this;
        const state = this.state;
        const show = state.show;
        const props = this.props;
        const additionalBodyClass = props.bodyClass || "";
        const cancelButtonText = props.cancelButtonText || "Cancel";
        const hideCancelButton = !!props.hideCancelButton;
        const buttons = !props.buttons ? false :
            props.buttons.map((btn, index) => {
                let isSavingResult = false;
                const { isSaving = null } = self.props;
                if (isSaving && typeof isSaving === 'function') {
                    isSavingResult = isSaving();
                }
                let disabled = typeof (btn.type) === 'string' && btn.type.toLowerCase() === 'submit' && (btn.disabled || !self.state.canSubmit || self.props.isLoading);
                if (btn.enabledAlways && !isSavingResult) { disabled = false; }
                let className = `btn ${btn.default ? ' btn-default' : ''} ${disabled ? ' disabled' : ''}  btn-modal-spinner`;
                return (
                    <button
                        key={`modal-btn-${index}`}
                        {...(typeof (btn.type) === 'string' && btn.type.toLowerCase() === 'submit' ? {ref: this.submitRef} : {})}
                        type={btn.type}
                        onClick={btn.onClick}
                        disabled={disabled}
                        className={className}
                    >
                        {btn.label}
                    </button>
                );
            });

        const footer = props.hideFooter ? false :
                <div>
                    {!hideCancelButton && <a className="btn btn-cancel" onClick={props.isSubmitDisabled ? null : this.close}>{cancelButtonText}</a>}
                    {buttons}
                </div>

        let children = React.Children.map(props.children, (child, index) => {
            return React.cloneElement(child, {
                clearFormErrors: this.clearFormErrors,
                formModel: () => {
                    if (this.refs.modalForm) {
                        return this.refs.modalForm.getModel();
                    }
                    return {};
                }
            });
        });

        return (
            <Modal
                show={show}
                onHide={props.isSubmitDisabled ? null : this.close}
                backdrop="static"
                className={"modalComponent " + additionalBodyClass}
            >
                <FormsyFormErrorsProvider ref={this.initFormErrorsProvider}>
                    <Formsy.Form
                        ref="modalForm"
                        style={{ textAlign: "left" }}
                        onChange={this.formChanged}
                        onValidSubmit={this.handleSubmit}
                        onValid={this.enableSubmit}
                        onInvalid={this.disableSubmit}
                        validateOnAttachToForm={false}
                        validateOnDetachFromForm={false}
                        validateOnFormMount={props.validateOnFormMount}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{props.title}</Modal.Title>
                            {props.headerContent}
                        </Modal.Header>
                        <Modal.Body>
                            {children}
                        </Modal.Body>
                        <Modal.Footer>
                            {footer}
                        </Modal.Footer>
                    </Formsy.Form>
                </FormsyFormErrorsProvider>
            </Modal>
        );
    }
}

    return FlexModal;
};

module.exports = initComponent;